import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'DatabaseShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c.361 0 .716 -.009 1.065 -.026"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 13v-7"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), _createTextVNode(" ")]);
  }
};